export default "__VITE_ASSET__BJ$eOicG__"